import { z } from 'zod';

export const MarketingContactSchema = z.object({
  name: z.string().min(1).max(200),
  email: z.string().email().max(320),
  phone: z.string().max(30).optional().or(z.literal('')),
  venue: z.string().max(200).optional().or(z.literal('')),
  message: z.string().min(1).max(5000),
  /** Honeypot: real users never fill this hidden field. */
  website: z.literal('').optional(),
});

export type MarketingContactData = z.infer<typeof MarketingContactSchema>;
